import Menu from 'adeliom-menu-js';

const settings = {
    stickyScrollTop: true,
    closeMenuOnScroll: true,
    responsiveBreakpoint: 960,
}


const menu = new Menu(settings);
menu.init();


const topMenuToggler = document.querySelector('[js-top-menu-toggler]');
const topMenuSubMenu = document.querySelector('[js-top-menu-submenu]');
const menuMobile = document.querySelector('[js-menu-mobile]');
const closeMenu = document.querySelector('[js-menu-burger]');
const backTopSubmenu = document.querySelector('[js-top-submenu-back]');

const topSubmenuActiveClass = 'top-submenu-is-open';


const openTopMenuSubmenu = () => {
    topMenuSubMenu.classList.add(topSubmenuActiveClass)
    menuMobile.classList.add(topSubmenuActiveClass)
}

const closeTopMenuSubmenu = () => {
    if (topMenuSubMenu.classList.contains(topSubmenuActiveClass)) {
        topMenuSubMenu.classList.remove(topSubmenuActiveClass)
    }
    if (menuMobile.classList.contains(topSubmenuActiveClass)) {
        menuMobile.classList.remove(topSubmenuActiveClass)
    }
}
if (window.innerWidth <= 960 && topMenuToggler && topMenuSubMenu && menuMobile) {
    topMenuToggler.addEventListener('click', openTopMenuSubmenu);
    closeMenu.addEventListener('click', closeTopMenuSubmenu);
    backTopSubmenu.addEventListener('click', closeTopMenuSubmenu);
}



// const header = document.querySelector('[js-header]')
// const menuBurger = document.querySelector('[js-menu-burger]')
// const menuContent = document.querySelector('[js-menu-content]')
// const menuDesktop = document.querySelector('[js-menu-desktop]')
// const menuBackdrop = document.querySelector('[js-menu-backdrop]')
// const itemsHaveChildren = document.querySelectorAll('.menu-item-has-children')
// const itemsHaveChildrenLink = document.querySelectorAll('.menu-item-has-children > a')
// const submenuBack = document.querySelectorAll('[js-submenu-back]')
// const activeClass = 'is-open';
//
// //////////////
// //SET VISIBILITY OF DESKTOP MENU AND MOBILE MENU
// //////////////
// const setMenu = () => {
//     if (window.innerWidth < 960) {
//         menuDesktop.setAttribute('aria', 'hidden');
//         menuContent.removeAttribute('aria')
//         menuContent.style.paddingTop = header.offsetHeight + 'px';
//     } else {
//         menuContent.setAttribute('aria', 'hidden');
//         menuDesktop.removeAttribute('aria')
//     }
// }
// setMenu();
// window.addEventListener('resize', setMenu)
//
// const toggleActiveClass = (el) => {
//     el.classList.toggle(activeClass);
// }
//
//
// const toggleMenu = () => {
//     let activeSubItem = document.querySelector('.menu-item-has-children.is-open');
//     if (activeSubItem) {
//         toggleActiveClass(activeSubItem);
//
//     }
//     if (document.body.classList.contains(activeClass)) {
//         setTimeout(() => {
//             menuContent.style.left = '0';
//         }, 300)
//     }
//     if (document.body.classList.contains('is-submenu-open')) {
//         document.body.classList.remove('is-submenu-open');
//     }
//     toggleActiveClass(document.body);
// }
//
//
// //////////////
// //TOGGLE Hamburger
// //////////////
// menuBurger.addEventListener('click', toggleMenu)
//
//
// //////////////
// //TOGGLE BACKDROP
// //////////////
// menuBackdrop.addEventListener('click', toggleMenu)
//
// //////////////
// //DISABLE HREF ON PARENT ITEMS
// //////////////
// const disableHref = () => {
//     itemsHaveChildren.forEach((element) => {
//         element.querySelector("a").removeAttribute("href");
//     })
// }
// disableHref()
//
// //////////////
// //TOGGLE SUBMENU ITEMS
// //////////////
//
// if (window.innerWidth < 960) {
//     itemsHaveChildrenLink.forEach((element) => {
//         element.addEventListener('click', (e) => {
//             document.body.classList.add('is-submenu-open');
//             if (element === e.target) {
//                 menuContent.style.left = '-100%';
//                 toggleActiveClass(element.parentNode);
//             }
//         })
//     })
//
//     submenuBack.forEach((backButton) => {
//         backButton.addEventListener('click', () => {
//             document.body.classList.remove('is-submenu-open');
//             menuContent.style.left = '0';
//             toggleActiveClass(backButton.closest('.is-open'));
//         })
//     })
// }
//
//  const topMenuDesktop = document.querySelector('[js-top-menu-desktop]')
//  const topMenuMobile = document.querySelector('[js-top-menu-mobile]')
//
//
// //////////////
// //TOP MENU ARIA
// //////////////
// const topMenuVisibility = () => {
//     if (window.innerWidth < 960) {
//         topMenuDesktop.setAttribute('aria', 'hidden');
//         topMenuMobile.removeAttribute('aria')
//     } else {
//         topMenuMobile.setAttribute('aria', 'hidden');
//         topMenuDesktop.removeAttribute('aria')
//     }
// }
// if (topMenuDesktop && topMenuMobile) {
//     topMenuVisibility();
//     window.addEventListener('resize', topMenuVisibility)
// }

// //////////////
// //CHOOSE AGENCY MOBILE
// //////////////
// const submenuAgency = document.querySelector('[js-submenu-agency]');
// const submenuAgencyToggler = document.querySelector('[js-submenu-agency-toggler]');
//
//
// submenuAgencyToggler.addEventListener('click', () => {
//     toggleActiveClass(submenuAgency);
//     document.body.classList.add('is-submenu-open');
//     menuContent.style.left = '-100%';
// })



